import * as React from 'react';
import omit from 'omit.js';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
function getNumberArray(num) {
    return num
        ? num
            .toString()
            .split('')
            .reverse()
            .map(i => {
            const current = Number(i);
            return isNaN(current) ? i : current;
        })
        : [];
}
function renderNumberList(position, className) {
    const childrenToReturn = [];
    for (let i = 0; i < 30; i++) {
        childrenToReturn.push(<p key={i.toString()} className={classNames(className, {
            current: position === i,
        })}>
        {i % 10}
      </p>);
    }
    return childrenToReturn;
}
const ScrollNumber = props => {
    const [animateStarted, setAnimateStarted] = React.useState(true);
    const [count, setCount] = React.useState(props.count);
    const [prevCount, setPrevCount] = React.useState(props.count);
    const [lastCount, setLastCount] = React.useState(props.count);
    if (prevCount !== props.count) {
        setAnimateStarted(true);
        setPrevCount(props.count);
    }
    React.useEffect(() => {
        setLastCount(count);
        let timeout;
        if (animateStarted) {
            // Let browser has time to reset the scroller before actually
            // performing the transition.
            timeout = setTimeout(() => {
                setAnimateStarted(false);
                setCount(props.count);
                if (props.onAnimated) {
                    props.onAnimated();
                }
            });
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [animateStarted, count, props.count, props.onAnimated]);
    const getPositionByNum = (num, i) => {
        const currentCount = Math.abs(Number(count));
        const lstCount = Math.abs(Number(lastCount));
        const currentDigit = Math.abs(getNumberArray(count)[i]);
        const lastDigit = Math.abs(getNumberArray(lstCount)[i]);
        if (animateStarted) {
            return 10 + num;
        }
        // 同方向则在同一侧切换数字
        if (currentCount > lstCount) {
            if (currentDigit >= lastDigit) {
                return 10 + num;
            }
            return 20 + num;
        }
        if (currentDigit <= lastDigit) {
            return 10 + num;
        }
        return num;
    };
    const renderCurrentNumber = (prefixCls, num, i) => {
        if (typeof num === 'number') {
            const position = getPositionByNum(num, i);
            const removeTransition = animateStarted || getNumberArray(lastCount)[i] === undefined;
            return React.createElement('span', {
                className: `${prefixCls}-only`,
                style: {
                    transition: removeTransition ? 'none' : undefined,
                    msTransform: `translateY(${-position * 100}%)`,
                    WebkitTransform: `translateY(${-position * 100}%)`,
                    transform: `translateY(${-position * 100}%)`,
                },
                key: i,
            }, renderNumberList(position, `${prefixCls}-only-unit`));
        }
        return (<span key="symbol" className={`${prefixCls}-symbol`}>
        {num}
      </span>);
    };
    const renderNumberElement = (prefixCls) => {
        if (count && Number(count) % 1 === 0) {
            return getNumberArray(count)
                .map((num, i) => renderCurrentNumber(prefixCls, num, i))
                .reverse();
        }
        return count;
    };
    const renderScrollNumber = ({ getPrefixCls }) => {
        const { prefixCls: customizePrefixCls, className, style, title, component = 'sup', displayComponent, } = props;
        // fix https://fb.me/react-unknown-prop
        const restProps = omit(props, [
            'count',
            'onAnimated',
            'component',
            'prefixCls',
            'displayComponent',
        ]);
        const prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
        const newProps = Object.assign(Object.assign({}, restProps), { className: classNames(prefixCls, className), title: title });
        // allow specify the border
        // mock border-color by box-shadow for compatible with old usage:
        // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
        if (style && style.borderColor) {
            newProps.style = Object.assign(Object.assign({}, style), { boxShadow: `0 0 0 1px ${style.borderColor} inset` });
        }
        if (displayComponent) {
            return React.cloneElement(displayComponent, {
                className: classNames(`${prefixCls}-custom-component`, displayComponent.props && displayComponent.props.className),
            });
        }
        return React.createElement(component, newProps, renderNumberElement(prefixCls));
    };
    return <ConfigConsumer>{renderScrollNumber}</ConfigConsumer>;
};
ScrollNumber.defaultProps = {
    count: null,
    onAnimated() { },
};
export default ScrollNumber;
